import React, {useState, useEffect} from "react";
import {Formik, Field, Form} from "formik";
import {TextField, Loading, MultiSelect, Select, PersianDataPicker,} from "components/form";
import {
   generate_uuid,
   dateTimeToserver,
   transformTranslateFromValues,
   transformTranslateServerValues,
} from "lib/helpers";
import {required, validationWrapper, number} from "lib/formValidations";

import Modal from "components/Modal";
import {useCore} from "store/core";
import Filters from "./Filters";

// components

export default function Add(props) {
   const core = useCore();

   useEffect(() => {
      core.dispatch(core.getProducts());
      core.dispatch(core.getFestivals());
      core.dispatch(core.getPackages());
   }, []);

   return (
      <>
         <Modal
            zIndex={992}
            show={props.show}
            handleClose={props.close}
            title={props.title}
         >
            <Formik
               initialValues={{status: 1, count: 1, use_count: 1, send_to_all: 0,filter_type:'all'}}
               onSubmit={async (values, {setSubmitting}) => {
                 
                 
                  await props.submit({
                     ...transformTranslateFromValues(values),
                     expire_date: dateTimeToserver(values.expire_date),
                     filter_date_from: dateTimeToserver(values.filter_date_from),
                     filter_date_to: dateTimeToserver(values.filter_date_to),
                  });
                  props.close();
                  setSubmitting(false);
               }}
               enableReinitialize
            >
               {({isSubmitting, dirty, values, setFieldValue}) => (
                  <Form>
                     <div className="modal-body gap-y-3">
                        <div className="intro-x grid md:grid-cols-12 md:gap-3">
                           <div className="col-span-4">
                              <Field
                                 placeholder="برچسب"
                                 label="برچسب :"
                                 name="tag"
                                 component={TextField}
                              />
                           </div>
                           <div className="col-span-2">
                              <Field
                                 placeholder="تعداد"
                                 label="تعداد :"
                                 name="count"
                                 type="number"
                                 component={TextField}
                                 validate={(value) =>
                                    validationWrapper(value, required, number)
                                 }
                              />
                           </div>

                           {values.count == 1 && (
                              <div className="col-span-4">
                                 <Field
                                    placeholder="HY-1400"
                                    label="کد :"
                                    name="code"
                                    style={{direction: "ltr"}}
                                    component={TextField}
                                    validate={(value) => validationWrapper(value, required)}
                                 />
                              </div>
                           )}
                           {values.count > 1 && (
                              <div className="col-span-4">
                                 <Field
                                    placeholder="HY-1400*****"
                                    label="پترن :"
                                    name="code"
                                    style={{direction: "ltr"}}
                                    component={TextField}
                                    validate={(value) => validationWrapper(value, required)}
                                 />
                              </div>
                           )}
                           <div className="col-span-3">
                              <Field
                                 placeholder="تعداد استفاده"
                                 label="تعداد استفاده :"
                                 name="use_count"
                                 type="number"
                                 component={TextField}
                                 validate={(value) => validationWrapper(value, required)}
                              />
                           </div>
                           <div className="col-span-3">
                              <Field
                                 placeholder="نوع تخفیف"
                                 label="نوع تخفیف :"
                                 name="type"
                                 component={Select}
                                 options={[
                                    {label: "قیمتی", value: "price"},
                                    {label: "درصدی", value: "percent"},
                                 ]}
                                 validate={(value) => validationWrapper(value, required)}
                              />
                           </div>
                           <div className="col-span-3">
                              <Field
                                 placeholder="تاریخ انقضا"
                                 label="تاریخ انقضا :"
                                 name="expire_date"
                                 component={PersianDataPicker}
                                 hasTime={true}
                                 format="YYYY/MM/DD HH:mm:ss"
                                 validate={(value) => validationWrapper(value, required)}
                              />
                           </div>
                           <div className="col-span-3">
                              <Field
                                 placeholder="میزان تخفیف"
                                 label="میزان تخفیف :"
                                 name="amount"
                                 type="number"
                                 component={TextField}
                                 validate={(value) => validationWrapper(value, required)}
                              />
                           </div>
                           <div className="col-span-3">
                              <Field
                                 placeholder="حداقل خرید"
                                 label="حداقل خرید :"
                                 name="min_buy"
                                 type="number"
                                 component={TextField}
                                 validate={(value) => validationWrapper(value, required)}
                              />
                           </div>
                           <div className="col-span-3">
                              <Field
                                 placeholder="حداکثر تخفیف"
                                 label="حداکثر تخفیف :"
                                 name="max_use_discount"
                                 type="number"
                                 component={TextField}
                                 validate={(value) => validationWrapper(value, required)}
                              />
                           </div>
                           <div className="col-span-4">
                              <Field
                                 label="برای محصولات :"
                                 name="product_types"
                                 component={MultiSelect}
                                 valueOnly={true}
                                 options={[
                                    {value: "All", label: "تمامی محصولات"},
                                    {value: "Festival", label: "جشنواره ها"},
                                    {value: "Package", label: "اشتراک ها"},
                                    {value: "Movie", label: "فیلم ها"},
                                    {value: "Music", label: "موزیک ها"},
                                    {value: "SerieEpisode", label: "سریال ها"},
                                    {value: "Screening", label: "اکران ها"},
                                    {value: "Physical", label: "محصولات فروشگاه"},
                                    {value: "Download", label: "اکران ها"},
                                 ]}
                                 alsoOnChange={(selected) => {
                                    if (selected.includes("All")) {
                                       setFieldValue("product_types", ["All"]);
                                    }
                                    core.dispatch(core.getProducts({types: selected}));
                                 }}
                                 validate={(value) => validationWrapper(value, required)}
                              />
                           </div>
                           {values.product_types &&
                           values.product_types.includes("Package") && (
                              <div className="col-span-4">
                                 <Field
                                    label="پکیج های :"
                                    name="selected_packages"
                                    component={MultiSelect}
                                    valueOnly={true}
                                    options={core.packages || []}
                                    validate={(value) =>
                                       validationWrapper(value, required)
                                    }
                                 />
                              </div>
                           )}

                           {values.product_types &&
                           values.product_types.includes("Festival") && (
                              <div className="col-span-4">
                                 <Field
                                    label="جشنواره های :"
                                    name="selected_festivals"
                                    component={MultiSelect}
                                    valueOnly={true}
                                    options={core.festivals || []}
                                    validate={(value) =>
                                       validationWrapper(value, required)
                                    }
                                 />
                              </div>
                           )}
                           {values.product_types &&
                           [
                              "Movie",
                              "Music",
                              "SerieEpisode",
                              "Screening",
                              "Physical",
                              "Download",
                           ].some((r) => values.product_types.includes(r)) && (
                              <div className="col-span-4">
                                 <Field
                                    label="محصولات های :"
                                    name="selected_products"
                                    component={MultiSelect}
                                    valueOnly={true}
                                    options={core.products || []}
                                    validate={(value) =>
                                       validationWrapper(value, required)
                                    }
                                 />
                              </div>
                           )}
                        </div>
                        <Filters   values={values}
                    setFieldValue={setFieldValue}/>
                     </div>

                     <div className="modal-footer text-right">
                        <button
                           className="btn btn-primary w-20"
                           type="submit"
                           disabled={!!(isSubmitting || !dirty)}
                        >
                           {" "}
                           {isSubmitting ? <Loading/> : "ذخیره"}
                        </button>
                        <button
                           type="button"
                           disabled={isSubmitting}
                           onClick={props.close}
                           className="btn btn-outline-secondary w-20 mr-1"
                        >
                           انصراف
                        </button>
                     </div>
                  </Form>
               )}
            </Formik>
         </Modal>
      </>
   );
}
